import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取民族列表
  static queryQuestById(params) {
    return request({
      url: `survey/quest/queryQuestById`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }
  static querySave(params) {
    return request({
      url: `survey/quest/save`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Questionnaire/QuestionnaireServ.js